import { injectTranslate } from '@core/i18n-legacy';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { scheduleCellFactory } from '../schedule-cell.component';
import { defineOfferTableColumn } from './utils';

export const scheduledPublishColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.ScheduledPublish,
  label: injectTranslate()('app.offers.table.scheduled_publish'),
  visible: true,
  geometry: {
    width: 180,
    minWidth: 180,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: scheduleCellFactory('jobScheduler', 'publishDate'),
}));
